import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { ClipLoader } from "react-spinners";
import { Line } from "react-chartjs-2";

import { useAnalytics } from "./context";

export const QuestionGraphs = () => {
  const { loading, report } = useAnalytics();

  if(!report) {
    return <></>
  }

  let suggestedMax = undefined;

  switch (report.formId) {
    case "0810E381-D1CD-4996-9C2E-4619A3B566AD":
      suggestedMax = 5;
      break;
    case "E889A966-B1A6-43FF-BCAA-C3138A0914F7":
      suggestedMax = 7;

      break;
    default:
      break;
  }

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Hide the legend
      },
      title: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Time",
        },
        ticks: {
          display: false,
        },
        grid: {
          display: false,
        },
      },
      y: {
        suggestedMin: 0,
        suggestedMax: suggestedMax,
        title: {
          display: true,
          text: "Scores",
        },
        ticks: {
          callback: function (value:any, index:any, values:any) {
            if (index === 0 || index === values.length - 1) {
              return value;
            }
            return "";
          }
        },
        grid: {
          display: false,
        },
      },
    },
  };

  if (loading)
    return (
      <div className="loader">
        <ClipLoader />
      </div>
    );

  if (!report || report.data.length === 0) {
    return <></>;
  }

  return (
    <>
      <h2>Average Score by question</h2>

      <div className="graphs-grid">
        {report.questions.map((question: any, idx: number) => {
          let qText = question.fieldName.replace(/\[pipe:2c206efb-b256-4ca2-8eb5-261e30dcd10b\]/g, "access");

          return (
            <div key={idx}>
              <div className="title">
              <h3>{qText}</h3>
              </div>
              <div className="graph">
                <Line data={question.data} options={options} />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
